<script setup>
import LowProductionServices from "@/services/LowProductionServices";
import { GERAR_OCORRENCIA } from "@/utils/constants/typeAttendance";
import { onMounted, ref } from "vue";
import { useRouter } from "vue-router";

const router = useRouter();

const lowProductionServices = new LowProductionServices();
let optionsList = ref([]);

function redirectRouterAttendace(item) {
  // Mesma rota para todos os tipos de ocorrência; `os_type` (id_opcao_atendimento)
  // define o fluxo e o payload em GenerateOcurrence (ex.: 35 = NAP lotada).
  router.push({
    name: "ocurrence-fix-address",
    query: {
      os_type: String(item.id_opcao_atendimento),
      name_type: item.opcao,
    },
  });
}

async function getServiceOptionList() {
  const response = await lowProductionServices.getServiceOptionList(GERAR_OCORRENCIA);
  optionsList.value = response;
}

onMounted(() => {
  getServiceOptionList();
});
</script>

<template>
  <q-page-container>
    <q-page class="">
      <section class="q-px-md q-py-lg flex column">
        <div class="header-page">
          <h4>Opções de geração de ocorrência</h4>

          <p>Selecione a opção de geração de ocorrência desejada:</p>
        </div>
        <div class="q-py-md options-list">
          <div
            v-if="!optionsList.length"
            class="col-12 full-height flex justify-center items-center"
          >
            <q-circular-progress
              indeterminate
              rounded
              size="60px"
              color="red"
              class="q-ma-md"
            />
          </div>
          <div
            class="option-items"
            v-else
            v-for="item in optionsList"
            :key="item.id_opcao_atendimento"
          >
            <q-btn
              rounded
              class="q-my-sm full-width"
              color="red-9"
              :label="item.opcao"
              @click="redirectRouterAttendace(item)"
              no-caps
            />
          </div>
        </div>
      </section>
    </q-page>
  </q-page-container>
</template>

<style lang="scss" scoped>
section {
  display: flex;
  height: 100vh;
  width: 100vw;
}

.header-page {
  h4 {
    font-size: 1rem;
    font-weight: 700;
    line-height: 19px;
    letter-spacing: 0em;
    text-align: left;
    color: red;
    margin: 0;
  }

  p {
    font-size: 0.875rem;
    font-weight: 500;
    line-height: 20px;
    letter-spacing: 0em;
    text-align: left;
    color: grey;
    margin: 0;
  }
}

.options-list {
  display: flex;
  flex: 1;
  flex-direction: column;
  overflow-y: auto;
}

.option-items {
  display: flex;
  width: 100%;
}
</style>
